import type { BoardRuntimeConfig } from "@/config/boardRuntimeConfig";

/** TanStack Routerへ渡すruntime board base pathを正規化する。 */
export function getBoardRouterBasepath(config: BoardRuntimeConfig): string {
  return config.publicBasePath || "/";
}
